<template>
  <div>
    <v-dialog
      v-model="dialog"
      persistent
      width="600px"
    >
      <v-card v-if="dialog">
        <v-card-title primary-title>
          {{ item.name }}
        </v-card-title>
        <v-card-text class="px-0">
          <v-row no-gutters justify="space-around">
            <!-- Image Preview -->
            <v-expand-transition>
              <v-col cols="12">
                <v-img :src="item.download_url ? item.download_url : require(`@/assets/img/BA/${item.name}`)" contain aspect-ratio="1">
                  <template v-slot:placeholder>
                    <v-row class="fill-height ma-0 grey lighten-5" align="center" justify="center" >
                      <v-progress-circular indeterminate color="grey"/>
                    </v-row>
                  </template>
                </v-img>
              </v-col>
            </v-expand-transition>
          </v-row>
        </v-card-text>
        <!-- Buttons -->
        <v-card-actions>
          <v-spacer/>
          <v-btn color="primary" @click="close()">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: 'images-preview',
  props: {
    TESTMODE: { type: Boolean, default: false },
    value: Boolean,
    item: { type: Object, default: () => {} },
  },
  data: () => ({
    dialog: false
  }),
  watch: {
    value (val) {
      this.dialog = val
    }
  },
  methods: {
    close () {
      this.dialog = false
      this.$emit('close')
    }
  }
}
</script>
